import React from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import Settings_nav from "./Settings_nav";
import config from "../../config";

const Notification_settings = () => {
  const [loading, setLoading] = React.useState(true);

  const [channels, setChannels] = React.useState({
    whatsapp: false,
    email: false,
  });

  const [status, setStatus] = React.useState({
    whatsapp: {
      booking_confirmation: false,
      pickup_completed: false,
      out_for_delivery: false,
      delivered: false,
    },
    email: {
      booking_confirmation: false,
      pickup_completed: false,
      out_for_delivery: false,
      delivered: false,
    },
  });

  // ---------------------------------------------------------
  // Notification Events
  // ---------------------------------------------------------
  const notificationEvents = [
    {
      name: "Booking Confirmation",
      key: "booking_confirmation",
    },
    {
      name: "In Transit",
      key: "pickup_completed",
    },
    {
      name: "Out For Delivery",
      key: "out_for_delivery",
    },
    {
      name: "Delivered",
      key: "delivered",
    },
  ];

  // ---------------------------------------------------------
  // Get Customer Details
  // ---------------------------------------------------------
  const getCustomerDetails = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        config.apiUrl + "/user/customer_detail",
        {},
        {
          headers: config.headers,
        }
      );

      const customer = response?.data?.output || {};

      // -----------------------------------------------------
      // Channel Status
      // -----------------------------------------------------
      setChannels({
        whatsapp: customer.whatsapp_notification === true,
        email: customer.email_notification === true,
      });

      // -----------------------------------------------------
      // WhatsApp Event Status
      // -----------------------------------------------------
      const whatsappArray = customer.whatsapp_array?.[0] || {};

      // -----------------------------------------------------
      // Email Event Status
      // -----------------------------------------------------
      const emailArray = customer.email_array?.[0] || {};

      setStatus({
        whatsapp: {
          booking_confirmation: whatsappArray.booking_confirmation === true,

          pickup_completed: whatsappArray.pickup_completed === true,

          out_for_delivery: whatsappArray.out_for_delivery === true,

          delivered: whatsappArray.delivered === true,
        },

        email: {
          booking_confirmation: emailArray.booking_confirmation === true,

          pickup_completed: emailArray.pickup_completed === true,

          out_for_delivery: emailArray.out_for_delivery === true,

          delivered: emailArray.delivered === true,
        },
      });
    } catch (error) {
      console.log("Notification settings customer detail error ===", error);
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // Initial Load
  // ---------------------------------------------------------
  React.useEffect(() => {
    getCustomerDetails();
  }, []);

  // ---------------------------------------------------------
  // Change Master Channel Status
  // ---------------------------------------------------------
  const changeChannelStatus = async (channel, value) => {
    try {
      // Optimistic UI update
      setChannels((prev) => ({
        ...prev,
        [channel]: value,
      }));

      let api = "";

      if (channel === "whatsapp") {
        api =
          config.apiUrl + "/user/customer_whatsapp_notification_status_change";
      }

      if (channel === "email") {
        api = config.apiUrl + "/user/customer_email_notification_status_change";
      }

      if (!api) {
        return;
      }

      const response = await axios.post(
        api,
        {
          status: value,
        },
        {
          headers: config.headers,
        }
      );

      if (response?.data?.status === true) {
        await getCustomerDetails();
      } else {
        await getCustomerDetails();
      }
    } catch (error) {
      console.log(`${channel} notification status change error ===`, error);

      await getCustomerDetails();
    }
  };

  // ---------------------------------------------------------
  // Change Individual Event Status
  // ---------------------------------------------------------
  const changeEventStatus = async (channel, statusKey, value) => {
    const previousStatus = status[channel][statusKey];

    // Optimistic UI update
    setStatus((prev) => ({
      ...prev,
      [channel]: {
        ...prev[channel],
        [statusKey]: value,
      },
    }));

    try {
      let api = "";

      if (channel === "whatsapp") {
        api =
          config.apiUrl +
          "/user/customer_whatsapp_notification_shipping_status_change";
      }

      if (channel === "email") {
        api =
          config.apiUrl +
          "/user/customer_email_notification_shipping_status_change";
      }

      if (!api) {
        return;
      }

      const newStatus = {
        ...status[channel],
        [statusKey]: value,
      };

      const response = await axios.post(
        api,
        {
          status: newStatus,
        },
        {
          headers: config.headers,
        }
      );

      if (response?.data?.status === true) {
        await getCustomerDetails();
      } else {
        // Revert if API failed
        setStatus((prev) => ({
          ...prev,
          [channel]: {
            ...prev[channel],
            [statusKey]: previousStatus,
          },
        }));

        await getCustomerDetails();
      }
    } catch (error) {
      console.log(
        `${channel} notification event status change error ===`,
        error
      );

      // Revert on error
      setStatus((prev) => ({
        ...prev,
        [channel]: {
          ...prev[channel],
          [statusKey]: previousStatus,
        },
      }));

      await getCustomerDetails();
    }
  };

  // ---------------------------------------------------------
  // Master Switch
  // ---------------------------------------------------------
  const handleChannelChange = (channel, e) => {
    const value = e.target.checked;

    changeChannelStatus(channel, value);
  };

  // ---------------------------------------------------------
  // Event Switch
  // ---------------------------------------------------------
  const handleEventChange = (channel, statusKey, e) => {
    const value = e.target.checked;

    changeEventStatus(channel, statusKey, value);
  };

  return (
    <div>
      <Header>
        <div className="content">
          {/* =================================================
              PAGE HEADER
          ================================================= */}
          <div className="ol-header">
            <div className="ol-hd">
              <button
                type="button"
                className="ol-back"
                title="Go back"
                onClick={() => window.history.back()}
              >
                <i className="bi bi-arrow-left"></i>
              </button>

              <div>
                <div className="ol-title">Notification Settings</div>

                <div className="ol-sub">
                  <span className="dot"></span>
                  Manage your notification preferences
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              CONTENT
          ================================================= */}
          <div className="row">
            {/* SETTINGS NAV */}

            {/* MAIN CONTENT */}
            <div className="col-12 col-md-12">
              <div className="card-base ns-card">
                {/* ==========================================
                    HEADER
                ========================================== */}
                <div className="ns-card-head">
                  <span className="ns-card-ic">
                    <i className="bi bi-bell"></i>
                  </span>

                  <div className="ns-card-tx">
                    <h2 className="ns-card-title">Notification Channels</h2>

                    <p className="ns-card-desc">
                      Turn notifications on or off and choose which events you
                      want to receive.
                    </p>
                  </div>
                </div>

                {/* ==========================================
                    LOADING
                ========================================== */}
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>

                    <div className="mt-2 text-muted">
                      Loading notification settings...
                    </div>
                  </div>
                ) : (
                  <>
                    {/* ======================================
                        CHANNEL MASTER SWITCHES
                    ====================================== */}
                    <div className="row mb-4">
                      {/* WHATSAPP */}
                      <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <div className="border rounded p-3 h-100">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div
                                className="me-3 d-flex align-items-center justify-content-center"
                                style={{
                                  width: "42px",
                                  height: "42px",
                                  borderRadius: "10px",
                                  background: "rgba(37, 211, 102, 0.10)",
                                }}
                              >
                                <i
                                  className="bi bi-whatsapp"
                                  style={{
                                    fontSize: "21px",
                                  }}
                                ></i>
                              </div>

                              <div>
                                <div className="fw-semibold">WhatsApp</div>

                                <div className="text-muted small">
                                  Receive WhatsApp notifications
                                </div>
                              </div>
                            </div>

                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="whatsappMasterSwitch"
                                checked={channels.whatsapp}
                                onChange={(e) =>
                                  handleChannelChange("whatsapp", e)
                                }
                              />

                              <label
                                className="form-check-label"
                                htmlFor="whatsappMasterSwitch"
                              >
                                {channels.whatsapp ? "On" : "Off"}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* EMAIL */}
                      <div className="col-12 col-md-6">
                        <div className="border rounded p-3 h-100">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div
                                className="me-3 d-flex align-items-center justify-content-center"
                                style={{
                                  width: "42px",
                                  height: "42px",
                                  borderRadius: "10px",
                                  background: "rgba(13, 110, 253, 0.10)",
                                }}
                              >
                                <i
                                  className="bi bi-envelope"
                                  style={{
                                    fontSize: "21px",
                                  }}
                                ></i>
                              </div>

                              <div>
                                <div className="fw-semibold">Email</div>

                                <div className="text-muted small">
                                  Receive email notifications
                                </div>
                              </div>
                            </div>

                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="emailMasterSwitch"
                                checked={channels.email}
                                onChange={(e) =>
                                  handleChannelChange("email", e)
                                }
                              />

                              <label
                                className="form-check-label"
                                htmlFor="emailMasterSwitch"
                              >
                                {channels.email ? "On" : "Off"}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ======================================
                        EVENTS
                    ====================================== */}
                    <div className="ns-table-wrap">
                      <table className="ns-table table">
                        <thead>
                          <tr>
                            <th className="ns-th-ev">Notification Type</th>

                            <th className="ns-th-ch">
                              <div className="ns-ch">
                                <span className="ns-ch-name">
                                  <i className="bi bi-whatsapp me-1"></i>
                                  WhatsApp
                                </span>
                              </div>
                            </th>

                            <th className="ns-th-ch">
                              <div className="ns-ch">
                                <span className="ns-ch-name">
                                  <i className="bi bi-envelope me-1"></i>
                                  Email
                                </span>
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {notificationEvents.map((event) => (
                            <tr key={event.key}>
                              {/* EVENT NAME */}
                              <td>
                                <span className="fw-medium">{event.name}</span>
                              </td>

                              {/* WHATSAPP */}
                              <td>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id={`whatsapp-${event.key}`}
                                    checked={status.whatsapp[event.key]}
                                    disabled={!channels.whatsapp}
                                    onChange={(e) =>
                                      handleEventChange(
                                        "whatsapp",
                                        event.key,
                                        e
                                      )
                                    }
                                  />

                                  <label
                                    className="form-check-label"
                                    htmlFor={`whatsapp-${event.key}`}
                                  >
                                    {status.whatsapp[event.key] ? "On" : "Off"}
                                  </label>
                                </div>
                              </td>

                              {/* EMAIL */}
                              <td>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id={`email-${event.key}`}
                                    checked={status.email[event.key]}
                                    disabled={!channels.email}
                                    onChange={(e) =>
                                      handleEventChange("email", event.key, e)
                                    }
                                  />

                                  <label
                                    className="form-check-label"
                                    htmlFor={`email-${event.key}`}
                                  >
                                    {status.email[event.key] ? "On" : "Off"}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* ======================================
                        INFO
                    ====================================== */}
                    <div className="ns-foot mt-3">
                      <i className="bi bi-info-circle"></i>

                      <span>
                        Enable a notification channel first, then choose the
                        events for which you want to receive notifications.
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Header>

      <Footer />
    </div>
  );
};

export default Notification_settings;
